const RAQGuidance = () => {
  return (
    <>
      <div className="mt-6 flex items-center gap-2 rounded bg-default-200 px-4 py-3 text-xs text-default-700">
        <span className="block w-1 self-stretch rounded-xl bg-default-700 " />
        <div>
          <p>
            We’ll use this info to find the right vetted experts for the job -
            we’ll then contact them for you
          </p>
          <p className="mt-2">
            Some trades may have paid more to receive your job details - they
            still match your criteria
          </p>
        </div>
      </div>
    </>
  );
};

export default RAQGuidance;
